import React, { useEffect, useState } from 'react'
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AddUpdate } from '../../../../ApiMethods/ApiMethods';
import swal from 'sweetalert';
import DataTable from 'react-data-table-component';
import { customStyles } from '../../Utility/Utility';
import { get_WalletData, get_WalletSingleData } from '../../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Loader/Loader';

const Wallet = () => {
    const dispatch = useDispatch()
    const customerID = Number(sessionStorage.getItem('ID'));
    const WalletData = useSelector((state) => state.feedBackReducer.WalletData);
    const WalletSingleData = useSelector((state) => state.feedBackReducer.WalletSingleData);
    const [EditValue, setEditValue] = useState()
    const [IsActive, setIsActive] = useState(true);
    const [postModal, setPostModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [WalletPackageID, setWalletPackageID] = useState('')
    const [loading, setloading] = useState(false);

    const [Value, SetValue] = useState({
        'PackageInfo': '', 'PackageAmt': '', 'GSTInfo': '', 'GSTAmt': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusAmt': '', 'status': '', 'SubTotalAmt': '', 'CreatedByUser': '1'
    });
    useEffect(() => {
        if (IsActive) {
            dispatch(get_WalletData('1', setloading))
        } else {
            dispatch(get_WalletData('0', setloading))
        }
    }, [IsActive, IsActive]);

    // const handleAddFormSubmit = async (event) => {
    //     event.preventDefault();
    //     let error = false;
    //     let errorMsg = '';
    //     if (Value.GSTInfo === "") {
    //         error = true;
    //         errorMsg = 'Please fill GSTInfo.';
    //     }
    //     if (Value.GSTAmt === "") {
    //         error = true;
    //         errorMsg = 'Please fill GSTAmt.';
    //     }
    //     if (Value.PackageAmt === "") {
    //         error = true;
    //         errorMsg = 'Please fill PackageAmt.';
    //     }

    //     if (!error) {
    //         await AddUpdate('WalletPackage/Insert_WalletPackage', Value);
    //         setPostModal(false);
    //         dispatch(get_WalletData(IsActive));
    //         swal('Good job!', 'Successfully Added', "success");
    //         SetValue({ 'PackageInfo': '', 'PackageAmt': '', 'GSTInfo': '', 'GSTAmt': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusAmt': '', 'status': '', 'SubTotalAmt': '', });
    //     } else {
    //         swal('Oops', errorMsg, "error");
    //     }
    // };


    const handleAddFormSubmit = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        
        // if (Value.GSTInfo === "") {
        //     error = true;
        //     errorMsg = 'Please fill GSTInfo.';
        // }
        if (Value.GSTAmt === "") {
            error = true;
            errorMsg = 'Please fill GSTAmt.';
        }
        if (Value.PackageAmt === "") {
            error = true;
            errorMsg = 'Please fill PackageAmt.';
        }
       
        // if (Value.BonusInfo !== "" && Value.BonusAmt === "") {
        //     error = true;
        //     errorMsg = 'Please fill Bonus Amt ';
        // }
        // if (Value.BonusAmt !== "" && Value.BonusInfo === "") {
        //     error = true;
        //     errorMsg = 'Please fill Bonus Info ';
        // }

        if (!error) {
            const postdata={
                "PackageInfo":Value.PackageInfo,"PackageAmt":Value.PackageAmt,"GSTInfo":Value.GSTInfo,"GSTAmt":Value.GSTAmt
            }
            await AddUpdate('WalletPackage/Insert_WalletPackage', postdata);
            setPostModal(false);
            dispatch(get_WalletData(IsActive, setloading));
            swal('Good job!', 'Successfully Added', "success");
            SetValue({ 'PackageInfo': '', 'PackageAmt': '', 'GSTInfo': '', 'GSTAmt': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusAmt': '', 'status': '', 'SubTotalAmt': '' });
        } else {
            swal('Oops', errorMsg, "error");
        }
    };

    const UpdateWallet = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        // if (Value.GSTInfo === "") {
        //     error = true;
        //     errorMsg = 'Please fill GSTInfo.';
        // }
        if (Value.GSTAmt === "") {
            error = true;
            errorMsg = 'Please fill GSTAmt.';
        }
        if (Value.PackageAmt === "") {
            error = true;
            errorMsg = 'Please fill PackageAmt.';
        }
        
        // if (Value.BonusInfo !== "" && Value.BonusAmt === "") {
        //     error = true;
        //     errorMsg = 'Please fill Bonus Amt';
        // }
        // if (Value.BonusAmt !== "" && Value.BonusInfo === "") {
        //     error = true;
        //     errorMsg = 'Please fill Bonus Info';
        // }
        if (!error) {
             const Updatedata={
                "PackageInfo":Value.PackageInfo,"PackageAmt":Value.PackageAmt,"GSTInfo":Value.GSTInfo,"GSTAmt":Value.GSTAmt,WalletPackageID:WalletPackageID
            }
            await AddUpdate('WalletPackage/Update_WalletPackage', Updatedata);
            setPostModal(false);
            dispatch(get_WalletData(IsActive, setloading));
            swal('Good job!', 'Successfully Added', "success");
            SetValue({ 'PackageInfo': '', 'PackageAmt': '', 'GSTInfo': '', 'GSTAmt': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusAmt': '', 'status': '', 'SubTotalAmt': '', });
            Reset(); setEditModal(false);

        } else {
            swal('Oops', errorMsg, "error");
        }
    };

    const Reset = () => {
        SetValue({
            ...Value,
            'PackageInfo': '', 'PackageAmt': '', 'GSTInfo': '', 'GSTAmt': '', 'TotalAmt': '', 'BonusInfo': '', 'CreatedTime': '', 'BonusAmt': '', 'status': '', 'SubTotalAmt': '',
        })
    }


const handleChange = (e) => {
    const { name, value } = e.target;

  
    if (name === "PackageAmt" || name === "GSTInfo") {
        if (!/^\d*\.?\d*$/.test(value)) {
            return;
        }
    }

    let updatedValue = { ...Value, [name]: value };

    const packageAmt = parseFloat(updatedValue.PackageAmt) || 0;
    const gstInfo = parseFloat(updatedValue.GSTInfo) || 0;

   
    if (name === "GSTInfo" || name === "PackageAmt") {
        const gstAmt = (packageAmt * gstInfo / 100);
        updatedValue.GSTAmt = Math.round(gstAmt); 
    }

   
    const subTotalAmt = packageAmt + (parseFloat(updatedValue.GSTAmt) || 0);
    updatedValue.SubTotalAmt = Math.round(subTotalAmt);

  
    updatedValue.TotalAmt = Math.round(subTotalAmt);

    SetValue(updatedValue);
};



    const columns = [
        {
            name: 'Package Info', selector: (row) => row.PackageInfo, sortable: true,
            format: (row) => (
                <>{row?.PackageInfo ? row?.PackageInfo.substring(0, 70) : ''}{row?.PackageInfo?.length > 40 ? '  . . .' : null} </>
            ),
        },
        {
            name: 'Package Amt', selector: (row) => row.PackageAmt, sortable: true
        },
        {
            name: 'Gst(%)', selector: (row) => row.GSTInfo, sortable: true
        },
        {
            name: 'GST Amt', selector: (row) => row.GSTAmt, sortable: true
        },
        // {
        //     name: 'Sub Total Amt', selector: (row) => row.SubTotalAmt, sortable: true
        // },
        // {
        //     name: 'Bonus Amt', selector: (row) => row.BonusAmt, sortable: true
        // },
        // {
        //     name: 'Total Amt', selector: (row) => row.TotalAmt, sortable: true
        // },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => <>
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item onClick={() => handleEditClick(row)}>Edit</Dropdown.Item>
                            <Dropdown.Item
                                className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.WalletPackageID, true, '0');
                                }}>
                                Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        }
    ]

    const columns1 = [
        {
            name: 'Package Info', selector: (row) => row.PackageInfo, sortable: true,
            format: (row) => (
                <>{row?.PackageInfo ? row?.PackageInfo.substring(0, 70) : ''}{row?.PackageInfo?.length > 40 ? '  . . .' : null} </>
            ),
        },
        {
            name: 'Package Amt', selector: (row) => row.PackageAmt, sortable: true
        },
        {
            name: 'Gst(%)', selector: (row) => row.GSTInfo, sortable: true
        },
        {
            name: 'GST Amt', selector: (row) => row.GSTAmt, sortable: true
        },
        // {
        //     name: 'Bonus Amt', selector: (row) => row.BonusAmt, sortable: true
        // },
        // {
        //     name: 'Total Amt', selector: (row) => row.TotalAmt, sortable: true
        // },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => <>
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item
                                className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.WalletPackageID, false, '1'); // Pass the new IsActive value
                                }}>
                                Active
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        }
    ]

    useEffect(() => {
        setWalletPackageID(WalletPackageID); dispatch(get_WalletSingleData(WalletPackageID));
    }, [WalletPackageID])

    useEffect(() => {
        if (WalletSingleData) {
            setEditValue(WalletSingleData);
        }
    }, [WalletSingleData]);

    const handleEditClick = (row) => {
        dispatch(get_WalletSingleData(row?.WalletPackageID)); setWalletPackageID(row?.WalletPackageID);
       
        setEditValue(WalletSingleData); setEditModal(true);
    };
    const handleToggleStatusClick = async (WalletPackageID, currentStatus, isActiveValue) => {
        const postData = {
            WalletPackageID: WalletPackageID, DeleteByUser: customerID, IsActive: isActiveValue,
        };
        await AddUpdate('WalletPackage/Delete_WalletPackage', postData);
        dispatch(get_WalletData(currentStatus ? '1' : '0', setloading))
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");
    };
    useEffect(() => {
        if (EditValue) {
            SetValue({
                ...Value,
                'WalletPackageID': WalletPackageID, 'PackageInfo': EditValue[0]?.PackageInfo, 'PackageAmt': EditValue[0]?.PackageAmt,
                'GSTInfo': EditValue[0]?.GSTInfo, 'GSTAmt': EditValue[0]?.GSTAmt, 'TotalAmt': EditValue[0]?.TotalAmt, 'BonusInfo': EditValue[0]?.BonusInfo, 'BonusAmt': EditValue[0]?.BonusAmt,
                'SubTotalAmt': EditValue[0]?.SubTotalAmt, 'CreatedTime': EditValue[0]?.CreatedTime,
            });
        }
    }, [EditValue]);

    return (
        <>
        <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Recharge Package</h2>
            <Tab.Container defaultActiveKey="All">
                <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
                    <div className="card-action coin-tabs mb-2">
                        <Nav as="ul" className="nav nav-tabs" role="tablist">
                            {/* <Nav.Item as="li" className="nav-item">
                                <Nav.Link className="nav-link" eventKey="All" onClick={(currentStatus) => {
                                    setIsActive(true);
                                }} >Active</Nav.Link>
                            </Nav.Item> */}
                            {/* <Nav.Item as="li" className="nav-item">
                                <Nav.Link className="nav-link" eventKey="Inactive" onClick={(currentStatus) => {
                                    setIsActive(false);
                                }}>Inactive</Nav.Link>
                            </Nav.Item> */}
                        </Nav>
                    </div>
                    <Link to={"#"} className="btn btn-primary font-w600 mb-2 " onClick={() => { setPostModal(true); Reset() }}>+ New Wallet</Link>
                </div>
                <div className="row ">
                    <div className="col-xl-12">
                        <div className="">
                            <div className=" p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                                            <Modal className="modal fade" show={postModal} onHide={() => setPostModal(false)} backdrop="static">
                                                <form>
                                                    <div className="modal-header">
                                                        <h4 className="modal-title fs-20">Add Wallet</h4>
                                                        <button type="button" className="btn-close" onClick={() => setPostModal(false)} data-dismiss="modal"></button>
                                                    </div>
                                                    <div className="modal-body p-3">
                                                        <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                        <div className="add-contact-box">
                                                            <div className="add-contact-content">
                                                                <div className="row">
                                                                    <div className="form-group mb-3 col-md-8">
                                                                        <label className="form-label" >Package Info</label>
                                                                        <input type="text" name="PackageInfo" placeholder="Enter" className="form-control"
                                                                            value={Value?.PackageInfo} onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group mb-3 col-md-4">
                                                                        <label className="form-label">Package Amt<span className="text-danger star-error" >*</span></label>
                                                                        
                                                                        <input type="text" name="PackageAmt" placeholder="Amt" required="required" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.PackageAmt} onChange={handleChange}

                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="form-group mb-2 col-md-8">
                                                                        <label className="form-label" >GST(%)</label>
                                                                        {/* <span className="text-danger star-error" >*</span> */}
                                                                        <input type="text" name="GSTInfo" placeholder="Enter Gst % " className="form-control"
                                                                            value={Value?.GSTInfo} onChange={handleChange} required="required"
                                                                        />
                                                                    </div>
                                                                    <div className="form-group  col-md-4">
                                                                        <label className="form-label">GST Amt <span className="text-danger star-error" >*</span></label>
                                                                       
                                                                        <input type="text" name="GSTAmt" placeholder="Amt" required="required" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.GSTAmt} onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {/* <div className="row">
                                                                    <div className="form-group mb-3 col-md-6">
                                                                    </div>
                                                                    <div className="form-group  col-md-6">
                                                                        <label className="form-label">Sub Total Amt</label>
                                                                        <input type="text" name="SubTotalAmt" placeholder="Amt" className="form-control readonly"
                                                                            value={Value?.SubTotalAmt} onChange={handleChange} readOnly
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <hr></hr>
                                                                <div className="row">
                                                                    <div className="form-group mb-2 col-md-8">
                                                                        <label className="form-label" >Bonus Info</label>
                                                                        <input type="text" name="BonusInfo" placeholder="Enter" className="form-control"
                                                                            value={Value?.BonusInfo} onChange={handleChange}

                                                                        />
                                                                    </div>
                                                                    <div className="form-group  col-md-4">
                                                                        <label className="form-label">Bonus Amt</label>
                                                                        <input type="text" name="BonusAmt" placeholder="Amt" className="form-control"
                                                                            maxLength={6}
                                                                            value={Value?.BonusAmt} onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="form-group mb-3 col-md-6">
                                                                    </div>
                                                                    <div className="form-group  col-md-6">
                                                                        <label className="form-label">Total Amt </label>
                                                                        <input type="text" name="TotalAmt" placeholder="Amt" className="form-control readonly"
                                                                            value={Value?.TotalAmt} onChange={handleChange} readOnly
                                                                        />
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="submit" className="btn btn-primary" onClick={handleAddFormSubmit}>Save</button>
                                                        <button type="button" onClick={() => { setPostModal(false); Reset('') }} className="btn btn-danger">
                                                            <i className="flaticon-delete-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </Modal>
                                        </div>
                                        <Modal className="modal fade " show={editModal} onHide={setEditModal} backdrop="static">
                                            <div className="" role="document">
                                                <div className="">
                                                    <form >
                                                        <div className="modal-header">
                                                            <h4 className="modal-title fs-20">Edit Wallet</h4>
                                                            <button type="button" className="btn-close" onClick={() => setEditModal(false)} data-dismiss="modal"></button>
                                                        </div>
                                                        <div className="modal-body p-3">
                                                            <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                            <div className="add-contact-box">
                                                                <div className="add-contact-content">
                                                                    <div className="row">
                                                                        <div className="form-group mb-3 col-md-8">
                                                                            <label className="form-label" >Package Info</label>
                                                                            <input type="text" name="PackageInfo" placeholder="Enter" className="form-control"
                                                                                value={Value?.PackageInfo} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group mb-3 col-md-4">
                                                                            <label className="form-label">Package Amt <span className="text-danger star-error" >*</span></label>
                                                                           
                                                                            <input type="text" name="PackageAmt" placeholder="Amt" className="form-control"
                                                                                value={Value?.PackageAmt} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="form-group mb-2 col-md-8">
                                                                            <label className="form-label" >GST(%)</label>
                                                                            {/* <span className="text-danger star-error" >*</span> */}
                                                                            <input type="text" name="GSTInfo" placeholder="Enter Gst %" className="form-control"
                                                                                value={Value?.GSTInfo} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group  col-md-4">
                                                                            <label className="form-label">GST Amt <span className="text-danger star-error" >*</span></label>
                                                                           
                                                                            <input type="text" name="GSTAmt" placeholder="Amt" className="form-control"
                                                                                value={Value?.GSTAmt} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="row">
                                                                        <div className="form-group mb-3 col-md-6">
                                                                        </div>
                                                                        <div className="form-group  col-md-6">
                                                                            <label className="form-label">Sub Total Amt</label>
                                                                            <input type="text" name="SubTotalAmt" placeholder="Amt" className="form-control readonly"
                                                                                value={Value?.SubTotalAmt} onChange={handleChange} readOnly
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <hr></hr>
                                                                    <div className="row">
                                                                        <div className="form-group mb-2 col-md-8">
                                                                            <label className="form-label" >Bonus Info</label>
                                                                            <input type="text" name="BonusInfo" placeholder="Enter" className="form-control"
                                                                                value={Value?.BonusInfo} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group  col-md-4">
                                                                            <label className="form-label">Bonus Amt</label>
                                                                            <input type="text" name="BonusAmt" placeholder="Amt" className="form-control"
                                                                                value={Value?.BonusAmt} onChange={handleChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="form-group mb-3 col-md-6">
                                                                        </div>
                                                                        <div className="form-group  col-md-6">
                                                                            <label className="form-label">Total Amt </label>
                                                                            <input type="text" name="TotalAmt" placeholder="Amt" className="form-control readonly"
                                                                                value={Value?.TotalAmt} onChange={handleChange} readOnly
                                                                            />
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="submit" className="btn btn-primary" onClick={UpdateWallet}>Update</button>
                                                            <button type="button" onClick={() => { setEditModal(false); Reset() }} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Modal>
                                        <div className="col-12 mt-2">
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <DataTable
                                                    dense
                                                    data={WalletData}
                                                    columns={columns}
                                                    selectableRowsHighlight
                                                    pagination
                                                    // onRowClicked={(row) => {
                                                    // }}
                                                    fixedHeader
                                                    persistTableHead={true}
                                                    noDataComponent={"There are no data to display"}
                                                    customStyles={customStyles}
                                                />)}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Inactive">
                                        <div className="row">
                                            <div className="col-12 mt-2">
                                                {loading ? (
                                                    <Loader />
                                                ) : (
                                                    <DataTable
                                                        dense
                                                        data={WalletData}
                                                        columns={columns1}
                                                        selectableRowsHighlight
                                                        highlightOnHover
                                                        pagination
                                                        // onRowClicked={(row) => {// setClickedRow(row);   // set_Edit_Value(row);
                                                        // }}
                                                        fixedHeader
                                                        persistTableHead={true}
                                                        customStyles={customStyles}

                                                        noDataComponent={"There are no data to display"}
                                                    />)}
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div >
            </Tab.Container >
        </>
    )
}

export default Wallet